<script>
    import Button from "../../../../components/Button.svelte";
    import {backofficeServiceHost, uuidv4} from "../../../../stores/magic-wallet-store";

    export let userRef
    export let selectedBalance
    export let updateFunction

    let operation = "deposit"
    let amountDelta = 0
    let currency = (selectedBalance ? selectedBalance[0] : "GTK")

    const performOperation = async () => {
        if (userRef && currency && (amountDelta > 0)) {
            const urlResolver = () => {
                if (operation === "deposit") {
                    return `${backofficeServiceHost}/magic-wallet/deposit`
                } else {
                    return `${backofficeServiceHost}/magic-wallet/withdraw`
                }
            }

            const externalTxId = uuidv4()
            const data = {
                amount: amountDelta,
                currency: currency,
                externalTxId: externalTxId,
                operatorId: "mrq",
                userRef: userRef,
                metaInfo: ""
            }

            console.log("Operation request")
            const response = await (await fetch(urlResolver(), {
                method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(data)
            })).json()

            selectedBalance = [response.currency, response.newBalance]

            updateFunction()
        }
    }
</script>
<main>
    <h3>Magic Wallet Operations</h3>
    <section class="wallet-operation-section">
        {#if (userRef)}
            <div>
                Operation
                <select bind:value={operation}>
                    <option value="deposit">Deposit</option>
                    <option value="withdraw">Withdraw</option>
                </select>
                Amount <input class="short-text" type="text" bind:value={amountDelta}> <input class="short-text" type="text" bind:value={currency}>
            </div>
            <div class="button-holder">
                <Button text="Perform operation" onClickFunction={performOperation}/>
            </div>
        {/if}
    </section>

</main>

<style>
    .short-text {

    }
</style>
